var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 21.2C17.7019 21.2 22 16.9019 22 11.6C22 6.29807 17.7019 2 12.4 2C7.09807 2 2.8 6.29807 2.8 11.6C2.8 13.1699 3.17685 14.6518 3.84501 15.9602C3.90773 16.083 3.92077 16.2257 3.87724 16.3566L2.31381 21.0566C2.1841 21.4466 2.55407 21.8178 2.94446 21.6894L7.67049 20.1352C7.80042 20.0924 7.94187 20.1054 8.06386 20.1672C9.36633 20.8278 10.8397 21.2 12.4 21.2Z",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 14.4869V15.9923C17.0003 16.1321 16.9716 16.2704 16.9155 16.3985C16.8594 16.5265 16.7771 16.6414 16.6739 16.7359C16.5707 16.8304 16.4489 16.9023 16.3163 16.9471C16.1836 16.9919 16.0431 17.0085 15.9036 16.9959C14.3564 16.8281 12.8702 16.3005 11.5645 15.4554C10.3496 14.685 9.31963 13.657 8.54767 12.4446C7.69793 11.1355 7.16912 9.64504 7.00408 8.09397C6.99152 7.95521 7.00804 7.81536 7.0526 7.68331C7.09716 7.55127 7.16878 7.42994 7.2629 7.32703C7.35703 7.22413 7.47158 7.14191 7.59929 7.08562C7.72699 7.02932 7.86504 7.00018 8.00465 7.00005H9.51304C9.75705 6.99765 9.99361 7.08389 10.1786 7.24269C10.3636 7.40148 10.4845 7.622 10.5186 7.86315C10.5823 8.34491 10.7004 8.81794 10.8706 9.27321C10.9382 9.45281 10.9529 9.64801 10.9128 9.83567C10.8727 10.0233 10.7795 10.1956 10.6443 10.332L10.0058 10.9693C10.7215 12.2256 11.7638 13.2658 13.0226 13.9801L13.6611 13.3428C13.7978 13.2079 13.9704 13.1149 14.1584 13.0749C14.3465 13.0349 14.5421 13.0495 14.722 13.117C15.1782 13.2869 15.6522 13.4047 16.1349 13.4683C16.3791 13.5027 16.6022 13.6254 16.7616 13.8133C16.9211 14.0011 17.0058 14.2408 16.9997 14.4869Z",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.96c2aabdd132ee4643d02e6fabb7328a.svg";
export { ForwardRef as ReactComponent };